const carouselItems = [
  {
    tag: '娱乐圈',
    title: '顶流明星私生活风波：最新爆料持续发酵',
    desc: '近日多位一线明星卷入私生活争议，多个独家爆料来源持续放出重磅消息，事件仍在升温。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20entertainment%20scene%20with%20warm%20spotlight%20and%20deep%20shadows%2C%20abstract%20dramatic%20composition%2C%20film%20noir%20aesthetic%2C%20crimson%20and%20amber%20tones%2C%20premium%20editorial%20photography%2C%20theatrical%20atmosphere%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=carousel-01&orientation=landscape',
    hot: true,
  },
  {
    tag: '社会热点',
    title: '某知名企业高管录音泄露：内部大瓜曝光',
    desc: '一段企业内部会议录音近日在网络疯传，涉及多位知名企业高管的争议性言论引发广泛讨论。',
    img: 'https://readdy.ai/api/search-image?query=Corporate%20office%20interior%20with%20dramatic%20lighting%20and%20deep%20contrast%2C%20warm%20amber%20tone%2C%20mysterious%20atmosphere%2C%20premium%20editorial%20style%2C%20abstract%20composition%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=carousel-02&orientation=landscape',
    hot: true,
  },
  {
    tag: '网红圈',
    title: '千万粉丝网红塌房实录：黑料全汇总',
    desc: '某平台头部网红近日被前员工实名举报多项违规行为，一份完整的时间线梳理引发粉丝震动。',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20social%20media%20influencer%20aesthetic%20with%20warm%20lighting%2C%20dark%20moody%20atmosphere%2C%20abstract%20composition%20with%20soft%20lens%20flares%2C%20premium%20editorial%20photography%2C%20crimson%20and%20gold%20tones%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=carousel-03&orientation=landscape',
    hot: false,
  },
  {
    tag: '体育圈',
    title: '联赛内部黑幕接连曝光：裁判争议升级',
    desc: '本赛季多场关键比赛裁判判罚引发巨大争议，多名业内人士匿名爆料揭开联赛内部黑幕。',
    img: 'https://readdy.ai/api/search-image?query=Sports%20arena%20with%20dramatic%20stage%20lighting%2C%20dark%20atmosphere%2C%20warm%20spotlight%20rays%2C%20abstract%20dramatic%20composition%2C%20premium%20editorial%20photography%2C%20amber%20and%20deep%20shadow%20tones%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=carousel-04&orientation=landscape',
    hot: false,
  },
  {
    tag: '科技圈',
    title: '某独角兽公司数据造假证据链曝光',
    desc: '一份长达百页的调查报告详细揭露了某科技独角兽公司的系统性数据造假行为，投资方已介入调查。',
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20tech%20office%20in%20dramatic%20moody%20lighting%2C%20dark%20atmosphere%20with%20warm%20glow%2C%20abstract%20composition%2C%20premium%20editorial%20photography%2C%20crimson%20and%20amber%20accents%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=carousel-05&orientation=landscape',
    hot: false,
  },
  {
    tag: '直播圈',
    title: '头部主播合约纠纷大揭秘：天价违约金',
    desc: '直播行业两大巨头因合约问题对簿公堂，知情人士爆料多份内部合同细节，涉及金额惊人。',
    img: 'https://readdy.ai/api/search-image?query=Livestream%20studio%20with%20dramatic%20cinematic%20lighting%2C%20warm%20moody%20atmosphere%2C%20dark%20and%20mysterious%20composition%2C%20premium%20editorial%20photography%2C%20amber%20and%20crimson%20tones%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=carousel-06&orientation=landscape',
    hot: true,
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-900 mb-3">焦点专题</h2>
          <p className="text-foreground-500 text-sm max-w-xl mx-auto">精选当下最受关注的黑料爆料与争议事件，全方位追踪报道</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselItems.map((item, i) => (
            <article
              key={i}
              className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200/60 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3 flex gap-2">
                  <span className="px-2.5 py-1 bg-accent-500 text-white text-xs font-medium rounded-md">
                    {item.tag}
                  </span>
                  {item.hot && (
                    <span className="px-2.5 py-1 bg-primary-500 text-white text-xs font-medium rounded-md flex items-center gap-1">
                      <i className="ri-fire-line" />
                      热门
                    </span>
                  )}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-base font-bold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-foreground-500 text-xs leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}